export default ".search{\r\n    width: 100%;\r\n}\r\n";